import React from 'react';
import { Row, Col, Button, Table, Badge } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { forEach as _forEach } from 'lodash';
import { SketchPicker } from 'react-color';

import { getNameInCurrentLanguage } from 'helpers/intl';

import { getTextColor } from 'components/forms/autocomplete/Color';
import FormLangInput from 'components/forms/FormLangInput';
import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';

import SimplePrompt from 'components/layout/SimplePrompt';
import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import { ROLE_ERP_MASTER } from 'js/constants';
import may from 'js/security';

class AttributeValues extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shownIndex: null,
    };
  }

  handleClick = index => {
    this.setState(prevState => ({ shownIndex: index === prevState.shownIndex ? null : index }));
  };

  closeDetails = () => {
    this.setState({ shownIndex: null });
  };

  addValue = (data = {}) => {
    let { entity, changeEntity } = this.props;
    let newAttributeValue = entity.createValue('values', [], data);
    let newValue = entity.getValues().slice();
    newValue.push(newAttributeValue);
    let newEntity = { ...entity.updateValue('values', newValue, []) };

    this.setState({ shownIndex: newValue.length - 1 });

    changeEntity(newEntity);
  };

  handleRemoveClick = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    this.removeEntry(index);
  };

  removeEntry = index => {
    let { entity, changeEntity } = this.props;
    let newValue = entity.getValues().slice();
    newValue.splice(index, 1);
    let newEntity = { ...entity.updateValue('values', newValue, []) };

    if (index < this.state.shownIndex) {
      this.setState(
        prevState => ({ shownIndex: prevState.shownIndex - 1 }),
        () => {
          changeEntity(newEntity);
        }
      );
    } else if (index == this.state.shownIndex) {
      this.setState({ shownIndex: null }, () => {
        changeEntity(newEntity);
      });
      changeEntity(newEntity);
    } else {
      changeEntity(newEntity);
    }
  };

  changeEntity = (propertyName, value, callback = null) => {
    let { entity, changeEntity } = this.props;
    const { shownIndex } = this.state;
    let newEntity = { ...entity.updateValue(propertyName, value, ['values', shownIndex]) };
    if (propertyName === 'standard' && value === true) {
      const values = entity.getValues();
      _forEach(values, (singleV, i) => {
        if (i !== shownIndex) {
          newEntity.updateValue('standard', false, ['values', i]);
        }
        if (i === values.length - 1) {
          changeEntity(newEntity, callback);
        }
      });
    } else {
      changeEntity(newEntity, callback);
    }
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
      appIntl,
      user,
    } = this.props;

    const { shownIndex } = this.state;
    const htmlType = entity.getType();
    let columns = [messages.name, messages.actions];
    if (entityLoaded && htmlType === 'colors') {
      columns = [messages.name, messages.color, messages.actions];
    }

    let tBody = [];
    if (entityLoaded && entity.getValues().length) {
      const values = entity.getValues();
      tBody = values.map((value, i) => {
        return (
          <tr
            key={i}
            class={(i === shownIndex ? 'shown ' : '') + (i % 2 ? 'even ' : 'odd ')}
            onClick={() => {
              this.handleClick(i);
            }}
          >
            <td class="v-align-middle semi-bold">
              {entity.getIsMultilanguage() && <IntlFormInlineSelector />}
              {getNameInCurrentLanguage(value.getValue(), appIntl)}
            </td>
            {entityLoaded && htmlType === 'colors' && (
              <td class="v-align-middle semi-bold">
                <Badge
                  style={{
                    background: value.getColor(),
                    color: getTextColor(value.getColor() ? value.getColor() : '#ffffff'),
                  }}
                  class="p-l-10 p-r-10"
                >
                  {value.getColor()}
                </Badge>
              </td>
            )}
            <td class="v-align-middle text-right">
              {i === shownIndex ? (
                <Button bsSize="sm" class="btn-rounded m-r-10">
                  <i class="fa fa-times" /> {messages.close}
                </Button>
              ) : (
                <Button bsSize="sm" class="btn-rounded m-r-10">
                  <i class="fa fa-pencil-alt" /> {messages.edit}
                </Button>
              )}
              {may(ROLE_ERP_MASTER, user.roles) && (
                <SimplePrompt
                  onSuccess={e => {
                    this.handleRemoveClick(e, i);
                  }}
                />
              )}
            </td>
          </tr>
        );
      });
    }

    if (entityLoaded && shownIndex !== null) {
      const data = entity.getValues()[shownIndex];

      // user wants to see a value edit form
      tBody.splice(
        shownIndex + 1,
        0,
        <tr key={'details-showing-' + shownIndex} class="row-details">
          <td colSpan={columns.length}>
            <Row>
              <Col xs={12} md={4}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p className="form-group-title">{messages.value}</p>
                    <div class="form-group-attached">
                      {entity.getIsMultilanguage() ? (
                        <FormLangInput
                          label={messages.value}
                          name="value"
                          value={data.getValue()}
                          meta={data.getValueMetaInformation()}
                          validation={data.getValueValidationResult()}
                          onChange={this.changeEntity}
                          disabled={disabled}
                        />
                      ) : (
                        <FormInput
                          label={messages.value}
                          name="value"
                          value={getNameInCurrentLanguage(data.getValue(), appIntl)}
                          meta={data.getValueMetaInformation()}
                          validation={data.getValueValidationResult()}
                          onChange={(name, value) => this.changeEntity(name, [{ lang: null, name: value }])}
                          disabled={disabled}
                        />
                      )}
                      {htmlType === 'select' && (
                        <div className="form-group form-group-default">
                          <FormSwitchery
                            name="standard"
                            checked={data.getStandard()}
                            value
                            label="Standard Wert"
                            onChange={(name, value) => {
                              this.changeEntity('standard', value);
                            }}
                          />
                        </div>
                      )}
                      {entityLoaded && htmlType === 'colors' && (
                        <div class="form-group form-group-default">
                          <label>{messages.color}</label>
                          <div class="hint-text">{data.getColor()}</div>
                          <div class="p-b-5">
                            <SketchPicker
                              disableAlpha
                              onChange={color => {
                                this.changeEntity('color', color.hex);
                              }}
                              color={{ hex: data.getColor() }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </td>
        </tr>
      );
    }

    return (
      <div class="clearfix padding-20 sm-padding-10">
        {entityLoaded && (
          <Row>
            <Col xs={12}>
              <Table responsive hover class="table-detailed">
                <thead>
                  <tr>
                    {columns.map((column, i) => {
                      return (
                        <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                          {column}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="tablerows"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={1}
                  component="tbody"
                >
                  {tBody}
                </ReactCSSTransitionGroup>
              </Table>

              <div class="m-t-10">
                <Button onClick={() => this.addValue()}>{messages.add_value}</Button>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(AttributeValues));
